
import FilterEdit from "../../../assets/filled/FilterEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FilterEditIcon({ className, dataTestid = "FilterEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <FilterEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
